import React, { memo, useState, useCallback, useEffect } from 'react'
import { FilterRow, Form, SearchIcon, SearchField } from './s'

const Search = ({ controlProps = {}, setSearch, searching, setSearching, salt }) => (
    <FilterRow>
        <Form>
            <SearchField
                salt={salt}
                className="compact"
                label={false}
                name="search"
                field={{ unsettable: true }}
                controlProps={{
                    ...controlProps,
                    autoFocus: searching
                }}
                onFocus={() => setSearching?.(true)}
                onBlur={() => setSearching?.(false)}
                onChange={({ search }) => setSearch(search)} />
            <SearchIcon size={16} />
        </Form>
    </FilterRow>
)

const search = (term, items) => {
    if(!term || typeof term !== 'string' || !items?.length) {
        return null
    }

    term = term.toLowerCase()

    const filter = items => items
        .map(item => {
            const {
                name,
                entities = []
            } = item

            const nameMatch = name.toLowerCase().includes(term)

            if(!entities.length) {
                return nameMatch ? item : null
            }

            const filteredEntities = filter(entities)
            const entitiesMatch = !!filteredEntities.length

            if(nameMatch || entitiesMatch) {
                return {
                    ...item,
                    entities: filteredEntities
                }
            }

            return null
        })
        .filter(Boolean)

    return filter(items)
}

export const useClientSearch = ({ items, enabled = false }) => {
    const [clientSearch, setClientSearch] = useState('')
    const [clientFiltered, setClientFiltered] = useState(null)
    const [clientSearching, setClientSearching] = useState(enabled)

    const performSearch = useCallback(() => {
        if(!enabled) {
            return
        }

        setClientFiltered(search(clientSearch, items))
    }, [enabled, clientSearch, items])

    useEffect(() => { performSearch() }, [performSearch])

    useEffect(() => {
        return () => {
            setClientSearch('')
            setClientFiltered(null)
            setClientSearching(false)
        }
    }, [enabled])

    return {
        setClientSearch,
        clientFiltered,
        clientSearching,
        setClientSearching
    }
}

export default Search